import { BlockchainNetwork } from "../constants.js"
import { blockchains } from "../blockchains/networksConfig.js"
import { getBlockchainFromNetwork } from "./getBlockchainFromNetwork.js"
import { EthereumNetwork } from "../graphql.js"

export const isValidAddress = (address: string, blockchain: BlockchainNetwork) => {
    let blockchainName: string = getBlockchainFromNetwork(blockchain)

    if (blockchainName === BlockchainNetwork.ethereum) {
        blockchainName = EthereumNetwork.Ethereum
    } else if (blockchainName === BlockchainNetwork.bitcoin) {
        blockchainName = 'bitcoin'
    }

    return blockchains.
        filter((b) => b.name === blockchainName || b.name === blockchain)
        .some((b2) => !!address.match(b2.regexp))
}

export function validateAddresses(addresses: string[], blockchain: BlockchainNetwork): string[] {
    const invalidAddresses = []

    for (const address of addresses) {
        if (!isValidAddress(address, blockchain)) {
            invalidAddresses.push(address)
        }
    }

    return invalidAddresses
}

export const isValidBlockchainAddress = (address: string, blockchain: BlockchainNetwork) =>
    isValidAddress(address, blockchain)
